export default __webpack_public_path__ + "static/char-s-12-kr-c4dfe86153dd6e8fcaefaf226ea67dc6.png";